import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-752463b1"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "page" };
const _hoisted_2 = { class: "card" };
const _hoisted_3 = { class: "" };
const _hoisted_4 = { class: "field" };
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { for: "point_type_id" }, "ポイント種類", -1));
const _hoisted_6 = { class: "field" };
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { for: "targetServiceText" }, "ブランド", -1));
const _hoisted_8 = { class: "field" };
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { for: "exchangeRate" }, "商品コード", -1));
const _hoisted_10 = { class: "input-with-prefix" };
const _hoisted_11 = { class: "field" };
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { for: "effective_period_date" }, "商品名", -1));
const _hoisted_13 = { style: { "display": "flex" } };
const _hoisted_14 = { class: "button-row" };
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("button", {
    class: "btn-setting",
    type: "submit"
}, "削除", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_ThreeLineTitle = _resolveComponent("ThreeLineTitle");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_ThreeLineTitle, {
                    msgLine1: 'ポイント対象外',
                    msgLine2: '商品コード削除',
                    submsgLine1: 'Point Excluded',
                    submsgLine2: 'Product Code',
                    submsgLine3: 'Delete'
                })
            ]),
            _createElementVNode("div", null, [
                _createElementVNode("form", {
                    onSubmit: _cache[5] || (_cache[5] = _withModifiers(
                    //@ts-ignore
                    (...args) => ($options.onSubmit && $options.onSubmit(...args)), ["prevent"]))
                }, [
                    _createElementVNode("div", _hoisted_4, [
                        _hoisted_5,
                        _withDirectives(_createElementVNode("input", {
                            id: "point_type_id",
                            type: "text",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (($data.form.point_type_id) = $event)),
                            disabled: ""
                        }, null, 512), [
                            [_vModelText, $data.form.point_type_id]
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                        _hoisted_7,
                        _withDirectives(_createElementVNode("input", {
                            id: "targetServiceText",
                            type: "text",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => (($data.form.brand_id) = $event)),
                            disabled: ""
                        }, null, 512), [
                            [_vModelText, $data.form.brand_id]
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                        _hoisted_9,
                        _createElementVNode("div", _hoisted_10, [
                            _withDirectives(_createElementVNode("input", {
                                id: "exchangeRate",
                                type: "text",
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => (($data.form.item_code) = $event)),
                                disabled: ""
                            }, null, 512), [
                                [_vModelText, $data.form.item_code]
                            ])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                        _hoisted_12,
                        _createElementVNode("div", _hoisted_13, [
                            _withDirectives(_createElementVNode("input", {
                                type: "text",
                                id: "effective_period_date",
                                name: "effective_period_date",
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => (($data.form.item_name) = $event)),
                                disabled: ""
                            }, null, 512), [
                                [_vModelText, $data.form.item_name]
                            ])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("button", {
                            class: "btn-back",
                            type: "button",
                            onClick: _cache[4] || (_cache[4] =
                                //@ts-ignore
                                (...args) => ($options.onCancel && $options.onCancel(...args)))
                        }, " 戻る "),
                        _hoisted_15
                    ])
                ], 32)
            ])
        ])
    ]));
}
